import {
  createTag,
  createTagVariables,
  deleteTag,
  deleteTagVariables,
  tags,
  tagsVariables,
  updateTag,
  updateTagVariables,
} from "#types/code-generator.ts";
import type { TypedDocumentNode } from "#types/graphql.d.ts";
import { gql } from "graphql-tag";

export const TagPayload = gql`
  fragment TagPayload on Tag {
    id
    hideInFilters
    order
    title
    department {
      id
      title
    }
    offerings {
      id
    }
    classes {
      id
    }
  }
`;

export const UpdateTagMutation = gql`
  mutation updateTag($data: TagCreateInput!, $where: UniqueInput!) {
    updateTag(data: $data, where: $where) {
      ...TagPayload
    }
  }
  ${TagPayload}
` as TypedDocumentNode<updateTag, updateTagVariables>;

export const DeleteTagMutation = gql`
  mutation deleteTag($id: String!) {
    deleteTag(where: { id: $id }) {
      id
    }
  }
` as TypedDocumentNode<deleteTag, deleteTagVariables>;

export const CreateTagMutation = gql`
  mutation createTag($data: TagCreateInput!) {
    createTag(data: $data) {
      ...TagPayload
    }
  }
  ${TagPayload}
` as TypedDocumentNode<createTag, createTagVariables>;

export const TagsQuery = gql`
  query tags($where: TagWhereInput) {
    tags(where: $where, orderBy: { order: asc }) {
      ...TagPayload
    }
  }
  ${TagPayload}
` as TypedDocumentNode<tags, tagsVariables>;
